import { memo, type VFC } from 'react'
import { FooterLogoOrange, FacebookIcon, LinkedinIcon, TwitterIcon } from './svg'
import './Footer.scss'

const Footer: VFC<{}> = () => (
  <footer className='panw-footer'>
    <div className='footer-row'>
      <div className='footer-c2'>
        <a className='footer-logo' href='https://www.paloaltonetworks.com/'>
          <FooterLogoOrange />
        </a>
      </div>
      <div className='footer-c2'>
        <h3>Company</h3>
        <ul>
          <li><a href='https://www.paloaltonetworks.com/company' rel='noopener noreferrer' target='_blank'>About Palo Alto Networks</a></li>
          <li><a href='https://www.paloaltonetworks.com/company/careers' rel='noopener noreferrer' target='_blank'>Careers</a></li>
        </ul>
      </div>
      <div className='footer-c2'>
        <h3>Legal Notices</h3>
        <ul>
          <li><a href='https://www.paloaltonetworks.com/legal-notices/privacy' rel='noopener noreferrer' target='_blank'>Privacy</a></li>
          <li><a href='https://www.paloaltonetworks.com/legal-notices/terms-of-use' rel='noopener noreferrer' target='_blank'>Terms of Use</a></li>
        </ul>
      </div>
      <div className='footer-c2'>
        <h3>Resources</h3>
        <ul>
          <li><a href='https://www.paloaltonetworks.com/company/subscriptions' rel='noopener noreferrer' target='_blank'>Email Subscription</a></li>
          <li><a href='https://live.paloaltonetworks.com/' rel='noopener noreferrer' target='_blank'>Live Community</a></li>
          <li><a href='https://apps.paloaltonetworks.com/logging-service-calculator' rel='noopener noreferrer' target='_blank'>Cortex Data Lake Estimator</a></li>
          <li><a href='https://status.paloaltonetworks.com/' rel='noopener noreferrer' target='_blank'>Service Status</a></li>
          <li><a href='https://www.paloaltonetworks.com/company/contact-support' rel='noopener noreferrer' target='_blank'>Support</a></li>
          <li><a href='https://www.paloaltonetworks.com/documentation' rel='noopener noreferrer' target='_blank'>Technical Documentation</a></li>
        </ul>
      </div>
      <div className='footer-c4'>
        <ul className='footer-social'>
          <li><a href='https://www.linkedin.com/company/palo-alto-networks' data-link-type='hub-social-icons' data-link-network='LinkedIn' rel='noopener noreferrer' target='_blank'><LinkedinIcon /></a></li>
          <li><a href='https://www.facebook.com/PaloAltoNetworks/' data-link-type='hub-social-icons' data-link-network='Facebook' rel='noopener noreferrer' target='_blank'><FacebookIcon /></a></li>
          <li><a href='https://twitter.com/PaloAltoNtwks' data-link-type='hub-social-icons' data-link-network='Twitter' rel='noopener noreferrer' target='_blank'><TwitterIcon /></a></li>
        </ul>
      </div>
    </div>
    <div className='footer-row'>
      © {new Date().getFullYear()} Palo Alto Networks, Inc. All rights reserved.
    </div>
  </footer>
)

export default memo(Footer)
